export default "__VITE_ASSET__c55b3bff__"